<template>
    <div>
        <buttonlist ref="SetBtn" @help="help" @search="search" @reflash="reflash" @exps="exp"></buttonlist>
        <div id="xpane-0">
        <vxe-table
                ref="singleTable"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                resizable
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                show-overflow="tooltip"
                style="width: 100%; margin-top:0px"
                :checkbox-config="{highlight: true, range: true}"
                :mouse-config="{selected:true, extension: true}"
        >
            <vxe-table-column show-overflow-tooltip field="just_year" :title="$t('getapi[1974]')" width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="just_month_start" :title="$t('getapi[12710]')" width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="just_month_end" :title="$t('getapi[12711]')" width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="order_type" :title="$t('getapi[2285]')" width="200"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="share_flg" :title="$t('getapi[552]')" width="100"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
            <vxe-table-column field="material_cost" :title="$t('getapi[8244]')" width="100" align="right">
                <template slot-scope="scope">
                    {{scope.row.material_cost | thousandth}}
                </template>
            </vxe-table-column>
            <vxe-table-column field="man_cost" :title="$t('getapi[8245]')" width="100" align="right">
                <template slot-scope="scope">
                    {{scope.row.man_cost | thousandth}}
                </template>
            </vxe-table-column>
            <vxe-table-column field="charge_cost" :title="$t('getapi[8246]')" width="100" align="right">
                <template slot-scope="scope">
                    {{scope.row.charge_cost | thousandth}}
                </template>
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[143]')" width="150"></vxe-table-column>
        </vxe-table>
        </div>

        <serce :isVisible="isVisible" queryData="finmonthoutavg" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '3_finscrapcostshareview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataDetail:{
                    year: '',
                    month: ''
                },
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                dataSet: [], //
                dataSet1: [],
                dataSet2: [],
                dataSet3: [],
                dataSet4: [],
                loading: false,
                SelectIndex: 0,
                // 系统外成本
                activeName: '0', // 当前选择的分页
                isVisible: false,
                queryData:[],
                scrollTop:0,
            };
        },
        beforeDestroy(){
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function(){
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                });
            },
        },
        mounted: function () {
            let that = this;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8938]"),this.$t("getapi[8045]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            reflash(){
                let that = this
                that.search()
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'finmonthoutavg');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            //查询
            getView(){
                let that = this
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: 1,
                    PageSize: 10000,
                    SelectIndex: 1,
                    Param: datac
                };
                that.$http.urlpost('/CostCalc/InvView/FinOutCostShareView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent
                    }
                })
            },
            exp(){
                let that = this
                let parm = {
                    PageIndex: 1,
                    PageSize: 10000,
                    SelectIndex: 1,
                    Param: [],
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[8938]')
                };
                that.$http.urlpost('/CostCalc/InvView/FinOutCostShareViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tab{
        border-spacing: 20px;
        font-size: 18px;
    }
    .el-table--mini, .el-table--small, .el-table__expand-icon{
        border: 1px solid #9cc1f5
    }
</style>
